import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'custom'
})
export class CustomPipe implements PipeTransform {

  transform(value: any, key?: any, column?: any): any {
    let data = 0;
    if(value){
    value[key].forEach((e) => {
     if (column === e.date) {
        data = e.count;
      }
    });
  }
    return data;
  }


}
